import { EventLevelUpCodes } from 'defs/events';
import { getTargetFromFactory, TargetTypes } from 'defs/notifications';
import { TargetsType } from 'types/NotificationTargets';

const targets: TargetsType = {
	[EventLevelUpCodes.Z01]: {
		primary: {
			type: TargetTypes.Close,
		},
	},
};

export type LevelLabelEnumType = 'L01' | 'L02' | 'L03' | 'L04' | 'L05' | 'L06' | 'L07' | 'L08' | 'L09' | 'L10';

export const levelLabels = {
	L01: '1',
	L02: '2',
	L03: '3',
	L04: '4',
	L05: '5',
	L06: '6',
	L07: '7',
	L08: '8',
	L09: '9',
	L10: '10',
};

export const get = (key: string) => getTargetFromFactory(targets, key);

export default targets;
